import { Request } from 'express';

export const getOrigin = (req: Request) => {
  if (!req) return 'http://localhost:4200';
  if (req.headers['custom-domain-host']) {
    const host = req.headers['custom-domain-host'];
    const protocol = req.hostname === 'localhost' ? 'http' : 'https';
    return `${protocol}://${host}`;
  }
  if (req.headers['x-forwarded-host']) {
    const protocol = req.headers['x-forwarded-proto'];
    const host = req.headers['x-forwarded-host'];
    return `${protocol}://${host}`;
  }

  if (req.hostname === 'localhost') {
    if (req.query.fakeDomain) {
      return `http://${req.query.fakeDomain}`;
    }
  }

  const host = req.headers.host;
  const protocol = req.hostname === 'localhost' ? 'http' : 'https';
  return `${protocol}://${host}`;
};
